import React, { useState, useEffect } from 'react';

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [voltouOnline, setVoltouOnline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setOffline(false);
      setVoltouOnline(true);
      setTimeout(() => setVoltouOnline(false), 3000);
    };
    const handleOffline = () => {
      setOffline(true);
      setVoltouOnline(false);
    };
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!offline && !voltouOnline) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '16px', left: '50%', transform: 'translateX(-50%)',
      zIndex: 9998, maxWidth: '360px', width: 'calc(100% - 32px)',
      background: offline ? '#1a1a1a' : '#1D9E75',
      color: '#fff', borderRadius: '10px', padding: '10px 16px',
      display: 'flex', alignItems: 'center', gap: '10px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
      animation: 'slideUp 0.3s ease',
    }}>
      <span style={{ fontSize: '16px' }}>{offline ? '📵' : '✅'}</span>
      <div>
        <div style={{ fontSize: '13px', fontWeight: '600' }}>
          {offline ? 'Sem conexão' : 'Conexão restabelecida'}
        </div>
        <div style={{ fontSize: '11px', opacity: 0.8 }}>
          {offline ? 'Verifique sua internet. Alguns dados podem estar desatualizados.' : 'Você está online novamente.'}
        </div>
      </div>
    </div>
  );
}
